import { render, staticRenderFns } from "./CourseDescriptionDialog.vue?vue&type=template&id=cf69adc4&"
import script from "./CourseDescriptionDialog.vue?vue&type=script&lang=ts&"
export * from "./CourseDescriptionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports